import * as React from 'react';
import { Skeleton } from 'antd';
import './InputSkeleton.less';

const InputSkeleton: React.FC = () => <Skeleton.Input className="input-skeleton" active />;

export default InputSkeleton;
